import { action } from 'satcheljs';

export const onFormSubmitted = action('onFormSubmitted', (hidePanel?: () => void) => ({ hidePanel }));
